import { GoalsOverview } from "../../../../../common/components/goals/GoalsOverview/GoalsOverview";
import { useUserGoalsPage } from "./hooks/useUserGoalsPage";

/**
 * Staff page on a user's profile ("Цели"): the exact view the user has on "Моите цели",
 * scoped to that user. Staff can also add, edit, reorder and delete goals.
 */
export const UserGoalsPage = () => {
  const { dataSource } = useUserGoalsPage();

  return <GoalsOverview dataSource={dataSource} />;
};
